function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 674,
  height: 194,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M502.434 2.902c9.231 0 16.714 6.52 16.714 14.563 0 8.042-7.483 14.562-16.714 14.562h-95.513c9.231 0 16.715 6.52 16.715 14.562s-7.484 14.562-16.715 14.562h52.532c9.231 0 16.715 6.52 16.715 14.562s-7.484 14.563-16.715 14.563H435.16c-11.64 0-21.076 6.52-21.076 14.562q0 8.042 14.327 14.562c9.232 0 16.715 6.52 16.715 14.562s-7.483 14.562-16.715 14.562H230.222c-9.231 0-16.714-6.52-16.714-14.562s7.483-14.562 16.714-14.562h-93.124c-9.232 0-16.715-6.52-16.715-14.562s7.483-14.562 16.715-14.562h95.512c9.232 0 16.715-6.52 16.715-14.563 0-8.042-7.483-14.562-16.715-14.562h-59.695c-9.231 0-16.715-6.52-16.715-14.562s7.484-14.562 16.715-14.562h95.513c-9.232 0-16.715-6.52-16.715-14.562s7.483-14.563 16.715-14.563zm0 58.25c9.231 0 16.714 6.519 16.714 14.561s-7.483 14.563-16.714 14.563c-9.232 0-16.715-6.52-16.715-14.563 0-8.042 7.483-14.562 16.715-14.562",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M561.704 33.56h-17.665m31.329-29.38h-37.11zm15.124 0h-4.799zM204.468 179.181h-21.553m9.227-33.212h-45.278zm-60.632 0h-11.127z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "M337.503 52.686c7.488-6.722 19.058-6.5 26.272.727 7.21 7.23 7.458 18.742.752 26.252l-27.03 27.068-27.024-27.068c-6.706-7.51-6.454-19.042.752-26.252 7.22-7.217 18.768-7.459 26.278-.727m21.758 5.23c-4.781-4.787-12.495-4.981-17.499-.487l-4.256 3.819-4.258-3.816c-5.02-4.5-12.718-4.303-17.512.491-4.75 4.75-4.989 12.352-.612 17.375L337.5 97.71 359.876 75.3c4.38-5.026 4.141-12.619-.615-17.384",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgHeart as ReactComponent };
export default __webpack_public_path__ + "979cf3b1c05b00def508840f226ac7c4.svg";